var _path, _rect, _path2, _path3, _path4, _rect2, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessPartnersGreyscaleb597E6Fe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5546 14.1925C16.8218 14.9405 16.4102 15.9549 16.4102 17.0126V20.8416H24.2246H32.039V17.0126C32.039 15.9549 31.6273 14.9405 30.8946 14.1925C30.1618 13.4446 29.168 13.0244 28.1318 13.0244H20.3174C19.2811 13.0244 18.2873 13.4446 17.5546 14.1925Z",
    fill: "#DEE2E6",
    stroke: "#495057",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.6416,
    y: 20.3694,
    width: 35.1648,
    height: 25.9233,
    rx: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6416 32.334C12.0952 35.1391 18.1171 36.6003 24.224 36.6003C26.1127 36.6003 27.9933 36.4605 29.8515 36.1844C34.0014 35.5679 38.0395 34.2715 41.8064 32.334",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6416 32.334C12.0952 35.1391 18.1171 36.6003 24.224 36.6003C26.1127 36.6003 27.9933 36.4605 29.8515 36.1844C34.0014 35.5679 38.0395 34.2715 41.8064 32.334M41.8064 26.634V24.3576C41.8064 23.2999 41.3948 22.2854 40.662 21.5375C39.9293 20.7896 38.9355 20.3694 37.8992 20.3694H10.5488C9.51255 20.3694 8.51874 20.7896 7.78599 21.5375C7.05325 22.2854 6.6416 23.2999 6.6416 24.3576V42.3045C6.6416 43.3623 7.05325 44.3767 7.78599 45.1246C8.51874 45.8725 9.51255 46.2927 10.5488 46.2927H37.8992C38.9355 46.2927 39.9293 45.8725 40.662 45.1246C41.3948 44.3767 41.8064 43.3623 41.8064 42.3045V30.6665",
    stroke: "#495057",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1844 30.7229C36.3963 30.7229 30.8936 36.6908 30.8936 44.0526H55.4752C55.4752 36.6908 49.9724 30.7229 43.1844 30.7229Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3584,
    y: 44.2683,
    width: 25.6543,
    height: 5.05691,
    rx: 1,
    fill: "#DEE2E6",
    stroke: "#495057",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1065 43.7549C55.1065 38.672 52.053 34.3171 47.7162 32.4971C44.3391 31.1147 40.3258 31.9405 40.3258 31.9405C39.6668 32.1062 39.0293 32.3279 38.4186 32.6003C34.2087 34.4778 31.2666 38.7657 31.2666 43.7549",
    stroke: "#495057",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4537 32.2245C40.4141 31.0932 41.3205 30.1545 42.4525 30.1545H43.9207C45.0526 30.1545 45.959 31.0932 45.9194 32.2245L45.5807 41.9065C45.543 42.9832 44.6592 43.8366 43.5819 43.8366H42.7913C41.7139 43.8366 40.8302 42.9832 40.7925 41.9065L40.4537 32.2245Z",
    fill: "#DEE2E6",
    stroke: "#495057",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPartnersGreyscaleb597E6Fe);
export default __webpack_public_path__ + "static/media/business-partners-greyscale.b597e6fe.d27323af34688f54c73b47e4778dd4e8.svg";
export { ForwardRef as ReactComponent };